import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UsersActionsComponent } from './users-actions.component';

const routes: Routes = [
  // Module is lazy loaded, see app-routing.module.ts
  { path: '', component: UsersActionsComponent, data: { title: 'Modificar cuenta de usuarios' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class UsersActionsRoutingModule { }
